export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Crypto ID:"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Мова"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Доброго ранку"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Добрый день"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Добрий вечір"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Доброї ночі"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выйти"])}
}